/* RESPONSIBLE TEAM: team-standalone */

import { ChannelTargetingBodyData } from '../definitions';

export default class FreshdeskChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.freshdesk';
  }

  get channels(): ChannelTargetingBodyData['channels'] {
    return [];
  }
}
